import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LoaderService } from "../../../shared/components/loader/loader.service";
import { LoaderComponent } from "../../../shared/components/loader/loader.component";
import { environment } from "../../../../environments/environment";
declare const gtag: any;
declare const fbq: any;
@Component({
  selector: "app-payment-success",
  imports: [LoaderComponent],
  templateUrl: "./payment-success.component.html",
  styleUrl: "./payment-success.component.scss",
})
export class PaymentSuccessComponent implements OnInit {
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    if (environment.production) {
      // Call tracking function with values and order-id from query params
        const amount = this.activatedRoute.snapshot.queryParamMap.get('value')|| '' ;
        const orderId = this.activatedRoute.snapshot.queryParamMap.get('orderId') || '';
        this.trackPurchase(amount, orderId);

    }
    //remove Query Params from URL
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {},
      replaceUrl: true,
    });

    setTimeout(() => {
      this.loaderService.hide();
      this.router.navigateByUrl("reg/assign-ticket", { replaceUrl: true });
    }, 3000);
  }

  /**
   * TRACKING FUNCTION
   * Call this immediately after payment success
   */
  trackPurchase(value: string, transactionId: string) {
    const val = this.safeValue(value);
    if (typeof gtag !== "undefined") {
      // 1. Fire Google Ads Conversion (Direct Injection)
      // This is CRITICAL for the 10-day sprint - Instant feedback for the ad algorithm
      gtag("event", "conversion", {
        send_to: environment.google_ads_conversion_id_label,
        value: val,
        currency: "INR",
        transaction_id: transactionId,
      });

      // 2. Fire GA4 Standard Purchase Event
      // This keeps your Analytics reports clean
      gtag("event", "purchase", {
        transaction_id: transactionId,
        value: val,
        currency: "INR",
        items: [
          {
            item_id: "KISAN_TICKET",
            item_name: "Kisan Agri Show Ticket",
            price: val,
          },
        ],
      });
    }

    // 3. Fire Meta Pixel Purchase
    if (typeof fbq !== "undefined") {
      fbq("track", "Purchase", {
        value: val,
        currency: "INR",
        content_ids: ["KISAN_TICKET"],
        content_type: "product",
      });
    }
  }

  safeValue(value: string): number {
    const numericValue = parseFloat(value);
    return !isNaN(numericValue) && numericValue >= 0 ? numericValue : 0;
  }
}
